// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  backendApiURL: "https://apiacc.codknox.com/",

  firebase: {
    apiKey: "AIzaSyDA_td-1sM-tFw6glv0akgA_wp1qT1xfqQ",
    authDomain: "adventchildrenchoirdev.firebaseapp.com",
    projectId: "adventchildrenchoirdev",
    storageBucket: "adventchildrenchoirdev.firebasestorage.app",
    messagingSenderId: "660457445029",
    appId: "1:660457445029:web:d05999567a251c5be79f4c",
    measurementId: "G-Q1GTVRFD1V",
  },
  // dev
  // backendApiURL: "https://api.adventchildrenschoir.org/",
  // firebase: {
  //   apiKey: "AIzaSyCMu5TmUJoD2eiCWX8NL6ze1t3rzeA0a2Y",
  //   authDomain: "adventchildrenchoir-e1241.firebaseapp.com",
  //   projectId: "adventchildrenchoir-e1241",
  //   storageBucket: "adventchildrenchoir-e1241.appspot.com",
  //   appId: "1:395850419121:web:ba3bb233d9c2a94e830b90",
  //   measurementId: "G-PX7QT1B3FG",
  // },
  // prod
};
